import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { Redirect } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux"
import loginBackStrip from '../../resources/loginBackStrip.png'
import HEConnectLogo from '../../resources/HE_CONNECT_LOGO.png'
import * as actions from '../../redux/authentication'

const Login = () => {
  const [username, setUsername] = useState(null)
  const [password, setPassword] = useState(null)
  const { loginError: error, authenticated } = useSelector(state => state.authentication)
  const dispatch = useDispatch()
  const handleClick = () => dispatch(actions.login(username, password))
  const handlePasswordReset = () => {
    let email = prompt('What\'s your email address?')
    if (email) dispatch(actions.forgotPassword(email))
  }

  return (
    <>
      {authenticated && <Redirect to='/' />}
      {!authenticated && <Container>
        <SideBar>
          <AnimatedDiv />
          <img alt='Healthera Logo' src={HEConnectLogo} />
          <SideBarHeader>With Healthera, <br /> Manage your pharmacies easily.</SideBarHeader>
        </SideBar>
        <LoginBox>
          <Header>Sign In</Header>
          <div>
            <Input label="Email" onChange={(event) => { setUsername(event.target.value) }}
              margin="normal"
              fullWidth />
            <Input label="Password" type="password"
              onChange={(event) => { setPassword(event.target.value) }}
              margin="normal"
              fullWidth />
            <ErrorBox error={error}>{error}</ErrorBox>
          </div>
          <Actions>
            <LoginButton onClick={handleClick} variant="contained" color="primary" aria-label="Login"> Sign in </LoginButton>
            <Link onClick={handlePasswordReset}>Forgot Password</Link>
          </Actions>
        </LoginBox>
      </Container>}
    </>
  )
}
export default (Login)

const slide = keyframes`
100% {background-position:400000px}
`;

const AnimatedDiv = styled.div`
&& 
{
  position:absolute;
  bottom:60px;
  animation:${slide} 1500s infinite;
  width:100%;
  height:40vh;
  background:url(${loginBackStrip});
  background-size:contain;
  background-size: auto 40vh;
}`

const SideBar = styled.div`
&& 
{
  width: 517px;
  background:#2f9d6d;
  overflow:hidden;
  position:relative;
  display:flex;
  padding-top:16vh;
  justify-content: center;
  @media (max-width: 1000px) {
    display:none;
  }
}

&& > img
{
  width:119px;
  height:41px;
  position:absolute;
  left:28px;
  top:38px;
}
`

const Container = styled.div`
&& 
{
  height: 100vh;
  width:100vw;
  overflow:hidden;
  display: flex;
}
`
const Input = styled(TextField)`
&&
{
  color: #2f9d6d;
  margin-bottom:57px;
}
&& input
{
  border-bottom:2px solid #2f9d6d;
}
`
const ErrorBox = styled.div`
&& 
{
height: ${props => props.error ? '60px' : '0'};
display:flex;
align-items:center;
transition: height 0.2s linear;
border-radius: 25px;
padding: ${props => props.error ? '16px' : '0'};
font-size: 12px;
width:307px;
background: #339D6D;
margin: 12px 0;
color:white;
}
`

const SideBarHeader = styled.h1`
&& 
{
font-family: Assistant;
font-weight: bold;
color: #ffffff;
font-size:28px;
line-height: 1.33;
position: absolute;
left: 27px;
top: 86px;
}
`

const Header = styled.h1`
&& 
{
font-family: Assistant;
font-size: 40px;
font-weight: bold;
color: #282828;
}
`

const Link = styled.p`
&&
{
width: 157px;
height: 23px;
font-family: Assistant;
font-size: 18px;
font-weight: 600;
color: #2f9d6d;
margin-top: 10px;
text-align: right;
}
`

const LoginBox = styled.div`
&&
{
display: flex;
flex: 1;
justify-content: center;
align-items: center;
flex-flow: column;
}
`

const Actions = styled.div`
display:flex;
justify-content: end;
cursor:pointer;
`

const LoginButton = styled(Button)`
&&
{
width: 183px;
height: 41px;
border-radius: 20.5px;
box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
background-color: #2f9d6d;
font-family: Assistant;
font-size: 18px;
font-weight: bold;
text-align: center;
color: #ffffff;
text-transform: capitalize;
}

&&:hover
{
  background:#11442A;
}
`
